import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { UserComponent } from './user.component';

@NgModule({
  declarations: [UserComponent],
  exports: [UserComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PoModule]
})
export class UserModule {}
